import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { CollectionListComponent } from './collection-list/collection-list.component';
import { PtpCollectionListComponent } from './ptp-collection-list/ptp-collection-list.component';

@Component({
	selector: 'app-collections',
	templateUrl: './collections.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./collections.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		CollectionListComponent,
		PtpCollectionListComponent,
	],
})
export class CollectionsComponent {}
